import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Schedules extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">


          <div className="new_banner">
            <div className="banner_content">
              <h1>CSCE 2025</h1>
              <h6>The 2025 World Congress in</h6>
              <h6>Computer Science, Computer Engineering, & Applied Computing (CSCE)</h6>
              <h6>July 21-24, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
          <h4 className="par_header">Program/Schedules</h4>
            <div className="par">
            {/* To download a copy of the Schedule Booklet in .pdf <a href="" target="_blank" rel="noopener noreferrer">Click Here</a> (current as of July 12, 2025) 
            <br/>
            To download a copy of the Schedule Booklet in .doc <a href="" target="_blank" rel="noopener noreferrer">Click Here</a> (current as of July 12, 2025)
            <br/>
            To download a copy of the Book of Abstracts <a href="" target="_blank" rel="noopener noreferrer">Click Here</a> (current as of July 12, 2025).

            <br/> <br/>

            To prepare the congress program/schedule, the title of all papers, authors names, affiliations were extracted from the meta-data of the draft paper submissions (manuscripts submitted by the authors for evaluation). Any changes to the titles of the papers, authors names, affiliations, ... are not reflected in this program. The FINAL versions of the papers (uploaded to the publication portal) will have the correct information.

            <br/> <br/>
            The ZOOM links will be provided (by email) to the REGISTERED authors, speakers, and participants by July 10, 2025. 
            <br/><br/>
            In case of questions during the conference dates (July 15-18, 2025), send email to: <b>CSCE.ZOOM@gmail.com</b> */}
            </div>
            
          
          </div>
          

        </div>
      </div>
    );
  }
}

export default Schedules;